import React, { Component, Fragment, ReactNode } from 'react';
import { withRouteData, } from 'react-static';
import {
  TwoColScrollLayout,
  TwoColStickyLayout,
  TwoColContentLayout,
  FlowStripeWrapper,
  ContentWrapper,
  ContentContainer
} from '@flow/components/ui';
import * as NavigationAction from "@flow/store/navigation/actions";
import { connect } from "react-redux";
import SEOTags from "@flow/components/seo/SEOTags";
import { renderImageCarousel } from '@flow/scenes/default/ui';
import BasicButton from '@flow/components/ui/button/BasicButton';
import FlowStripe from '@flow/components/ticker/FlowStripe';
import { InjectedIntl, InjectedIntlProps, injectIntl } from 'react-intl';
import { IPage } from 'types/IPage';
import em from 'polished/lib/helpers/em';
import styled from 'styled-components';
import { TextAnimation } from '@flow/components/animation/TextAnimation';
import { getVenueNameByID, groupByKey } from '@flow/utils/helperUtils';
import { Event } from 'types/IArtist';
import moment from 'moment';
import Moment from 'react-moment';
import FoodMenu from '@flow/scenes/foods/FoodMenu';

const PageInfoHeader = styled.header`
  margin-bottom: 7.5em;
`;

const PageTitle = styled.h1`
  font-family: Flow-LightDisplay !important;
  text-align: center;
  margin-top: ${em(9.5, 10)};
  margin-bottom: ${em(2.5, 10)} !important;
`;

const EventData = styled.span`
  display: block;
  text-align: center;
  font-size: 2.1em;
  text-transform: uppercase;
  font-family: Flow-Poster-Bold, sans-serif;
`;

const VenueData = EventData.extend`
  margin-top: ${em(2.25, 2.1)};
  margin-bottom: ${em(1.5, 2.1)};
  
  &:first-child {
    margin-top: 0;
  }
`;

const EventDate = EventData.extend`
`;

interface Props {
  appLanguage: IAppLanguage;
  page: IPage;
  slugBases: any;
  _setLanguage: any;
  intl: InjectedIntl;
}

interface State {
  canTitleAnimate: boolean;
}

class SimplePage extends Component<Props & InjectedIntlProps, State> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.state = {
      canTitleAnimate: false
    };
  }

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page: {
        lang_versions
      }
    } = this.props;

    _setLanguage({appLanguage, lang_versions});
  }

  componentWillReceiveProps({
    appLanguage,
    page: {
      lang_versions
    },
  }: Props) {
    const {
      _setLanguage,
    } = this.props;

    _setLanguage({appLanguage, lang_versions});
  }

  componentDidMount() {
    this.setState({canTitleAnimate: true});
  }

  render() {
    const {
      page,
      intl
    } = this.props;

    const { canTitleAnimate } = this.state;
    const { type, parent_link, events } = page;

    return (
      <TwoColScrollLayout>
        <SEOTags artist={page}/>
        <TwoColStickyLayout>
          { renderImageCarousel(page.images) }
        </TwoColStickyLayout>
        <TwoColContentLayout>
          <FlowStripeWrapper>
            <FlowStripe animate={true} rotation={90} color={'#000000'} />
          </FlowStripeWrapper>
          <ContentWrapper>
            <BasicButton
              label={intl.formatMessage({ id: type + '.backButtonLabel' })}
              href={parent_link || '/'}
              showAsBackArrow={true}
            />
            <ContentContainer>
              <PageInfoHeader>
                <PageTitle>
                  <TextAnimation
                    text={page.title}
                    animateIn={canTitleAnimate}
                  />
                </PageTitle>
                {this._renderEventsData(events)}
              </PageInfoHeader>
              <ContentContainer dangerouslySetInnerHTML={{__html: page.content_group.content}}/>
              {type === 'food' && Boolean(page.menu) &&
                <FoodMenu menu={page.menu} />
              }
            </ContentContainer>
          </ContentWrapper>
        </TwoColContentLayout>
      </TwoColScrollLayout>
    );
  }

  private _renderEventsData = (events?: Event[]): ReactNode => {
    if (!events) {
      return null;
    }

    const distinctVenues = groupByKey(events, 'venue_id');
    return Object.keys(distinctVenues).map((venueId: any, key: number): ReactNode => {
      const venue: string = getVenueNameByID(parseInt(venueId, 10));
      return (
        <Fragment key={key}>
          {venue !== 'TBA' && <VenueData>{venue}</VenueData>}
          {distinctVenues[venueId].map((event: Event, idx: number) => {
            return (
              <EventDate key={idx}>
                {this._renderEventData(event)}
              </EventDate>
            );
          })}
        </Fragment>
      );
    });
  }

  private _renderEventData = (event: Event): ReactNode => {
    if (!moment(event.date).isValid()) {
      return null;
    }

    const { appLanguage } = this.props;

    return (
      <div style={{ marginTop: '.25em'}}>
        <Moment locale={appLanguage.code} format={'ddd D.M.'} date={event.date}/>
        { event.time &&
        <span>
          <span className='dingbats'> ⬟ </span>
          {event.time}
        </span>
        }
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions}: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  }
};

export default injectIntl(connect(
  null,
  mapDispatchToProps
)(withRouteData(SimplePage)));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/simple/SimplePage.tsx